import React from 'react';

const Download = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			data-name="Group 1004"
			viewBox="0 0 21.382 21.341"
			className={className}
		>
			<path
				fill="currentColor"
				d="M21.092 14.811a1.014 1.014 0 0 0-.714-.3 1.013 1.013 0 0 0-1.01 1.01v3.79H2.02v-3.79a1.014 1.014 0 0 0-.3-.714 1.014 1.014 0 0 0-.714-.3 1.013 1.013 0 0 0-1.01 1.01v4.733a.8.8 0 0 0 .013.182 1.013 1.013 0 0 0 1 .9h19.342a1.016 1.016 0 0 0 .99-.815 1.077 1.077 0 0 0 .034-.263v-4.733a1.067 1.067 0 0 0-.283-.71Z"
				data-name="Path 183"
			/>
			<path
				fill="currentColor"
				d="m9.836 15.753.027.027a1.149 1.149 0 0 0 .653.33c.02 0 .04.007.061.007l.114.007a.737.737 0 0 0 .121-.007c.02 0 .04-.007.061-.007a1.169 1.169 0 0 0 .653-.33c.007-.007.02-.013.027-.027l4.962-4.962a1.206 1.206 0 0 0 .02-1.67 1.187 1.187 0 0 0-1.67 0l-2.978 2.986V1.178a1.164 1.164 0 0 0-.343-.835A1.2 1.2 0 0 0 10.709 0a1.184 1.184 0 0 0-1.178 1.178v10.929L6.549 9.125a1.187 1.187 0 0 0-1.67 0 1.177 1.177 0 0 0-.343.835 1.177 1.177 0 0 0 .343.835Z"
				data-name="Path 184"
			/>
		</svg>
	);
};

export default Download;
